/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Work date units
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type WorkDateUnitEnum = 'Year' | 'Quarter' | 'Month' | 'Day' | 'Full Project Timespan';

export const WorkDateUnitEnum = {
    Year: 'Year' as WorkDateUnitEnum,
    Quarter: 'Quarter' as WorkDateUnitEnum,
    Month: 'Month' as WorkDateUnitEnum,
    Day: 'Day' as WorkDateUnitEnum,
    FullProjectTimespan: 'Full Project Timespan' as WorkDateUnitEnum
};

marker('Year');
marker('Quarter');
marker('Month');
marker('Day');
marker('Full Project Timespan');

